import { WATERFALL_EVENTS_DATA, WATERFALL_EVENTS_DATA_ERROR, WATERFALL_EVENTS_DATA_SUCCESS, WATERFALL_EVENTS_UPDATE, WATERFALL_EVENTS_UPDATE_ERROR, WATERFALL_EVENTS_UPDATE_SUCCESS, WATERFALL_GRAPH, WATERFALL_GRAPH_CONFIG, WATERFALL_PIPELINE_CONFIG_DATA, WATERFALL_PIPELINE_CONFIG_DATA_ERROR, WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS, WATERFALL_RESET } from './constants';

export default function microseismicData(state, action) {
 
	switch (action.type) {
	
	case WATERFALL_GRAPH: {
		const oldData = state.graphData?.data || [];
		const newData = action.payload.data || [];

		return {
			...state,
			graphData: {
				...action.payload,
				data: [...oldData, ...newData].slice(-500)
			}
		};
	}
	
	case WATERFALL_PIPELINE_CONFIG_DATA:
		return { ...state, loading : true, error : false};
	case WATERFALL_PIPELINE_CONFIG_DATA_SUCCESS:
		return { ...state, loading : false, error : false, piplineGroups : action.payload};
	case WATERFALL_PIPELINE_CONFIG_DATA_ERROR:
		return { ...state, loading : false, error : true};

	case WATERFALL_GRAPH_CONFIG:
		return { ...state, graphConfig : action.payload && action.payload.data ? action.payload.data[0] : {}};

	case WATERFALL_EVENTS_DATA:
		return { ...state, loading : true, error : false};
	case WATERFALL_EVENTS_DATA_SUCCESS:
		return { ...state, loading : false, error : false, waterfallEvents : action.payload};
	case WATERFALL_EVENTS_DATA_ERROR:
		return { ...state, loading : false, error : true, waterfallEvents : []};

	case WATERFALL_EVENTS_UPDATE:
		return { ...state, loading : true, error : false};
	case WATERFALL_EVENTS_UPDATE_SUCCESS:
		return { ...state, loading : false, error : false};
	case WATERFALL_EVENTS_UPDATE_ERROR:
		return { ...state, loading : false, error : true};
	
	case WATERFALL_RESET:
		return {
			...state,
			graphData: {
				data: [],
				times: [],
				depths: []
			}
		};
	
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}